/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import ApiSetupFrom from "./ApiSetup/ApiSetupFrom";
export const APISetUp = (props) => {

    return (
        <>
            <div className="row align-content-start position-relative" style={{minHeight: "76vh"}}>
                <div className="col-12">  
                    <ApiSetupFrom userinfo={props.userinfo} language={props.language}/>
                </div>
            </div>
        </>
    );
};
